"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * These breakpoints are used in various Less files via the `atLeastXYZScreen`
 * mixins, so make sure to make keep the values in sync with the values defined
 * in `src/less/shared/breakpoints.less`.
 */
exports.mediumScreenMinWidth = 480;
exports.largeScreenMinWidth = 768;
exports.extraLargeScreenWidth = 912;
//# sourceMappingURL=style.js.map
